import { Component, Output, EventEmitter, ChangeDetectorRef, Input, ChangeDetectionStrategy } from '@angular/core';

import { GeoServices } from '../../../services/geo.service';
import { FormComponentI } from '../../../shared/interfaces/form-component-i.interface';
import { InternalStateEvent } from '../../../shared/models/internal-state-event';
import { StateMiscArgument, CustomerTemplateState } from 'nm-socle-application/app/shared/models/customer-config';
import { TemplateInitService } from 'nm-socle-application/app/shared/services/template-init.service';
import { TemplateCurrentState } from 'nm-socle-application/app/shared/models/template-current-state';
import {AbstractComponent} from 'nm-socle-application/app/shared/models/abstract-component';

@Component({
    selector: 'login-result',
    templateUrl: './login-result.component.html',
    styleUrls: ['./login-result.component.scss'],
    changeDetection:ChangeDetectionStrategy.OnPush,
})
export class LoginResultComponent extends AbstractComponent implements FormComponentI {
    public static SUCCESS:string = 'sent';
    public static PENDING:string = 'pending';
    public static FAIL:string = 'fail';
    public static WARN:string = 'warn';

    @Input() public title: string;
    @Input() public icon: string;
    @Input() public color:string;

    @Output() public closeEvent: EventEmitter<any> = new EventEmitter();
    @Output() public internalStateEvent: EventEmitter<InternalStateEvent> = new EventEmitter();
    @Input() public misc:StateMiscArgument[] = [];

    constructor(
        public geoServices: GeoServices,
        protected _cd:ChangeDetectorRef,
        private _templateInitService:TemplateInitService,
    ) {
        super(_cd);
    }

    public ngOnInit() {
        super.ngOnInit();

        // TODO trad
        this._subs.push(this._templateInitService.currentState$.subscribe(curState => {
            let custTpl:CustomerTemplateState = this._templateInitService.getState(curState.state);

            let titleSuccess:string;
            let titlePending:string;
            let titleFail:string;

            if(custTpl != undefined && custTpl.main != undefined) {
                let miscTitleSuccess:StateMiscArgument = custTpl.main.getMisc('validSuccessLabel');
                titleSuccess = miscTitleSuccess.value;

                let miscTitlePending:StateMiscArgument = custTpl.main.getMisc('validPendingLabel');
                titlePending = miscTitlePending.value;

                let miscTitleFail:StateMiscArgument = custTpl.main.getMisc('validFailLabel');
                titleFail = miscTitleFail.value;
            }

            if(curState.getArgumentByName('valid') != undefined) {
                switch(curState.getArgumentByName('valid').value) {
                    case LoginResultComponent.SUCCESS:
                        this.icon = 'fa-check-circle';
                        this.title = titleSuccess;
                        this.color = 'green';
                    break;
                    case LoginResultComponent.PENDING:
                        this.icon = 'fa-check-circle';
                        this.title = titlePending;
                        this.color = 'green';
                    break;
                    case LoginResultComponent.FAIL:
                    case LoginResultComponent.WARN:
                        this.icon = 'fa-exclamation-triangle';
                        this.title = titleFail;
                        this.color = 'red';
                    break;
                }
            }

            this.internalStateEvent.emit(new InternalStateEvent({title: this.title}));
        }));
        this.markForCheck();
    }

    public goLoginForm() {
        this._templateInitService.setCurrentState(new TemplateCurrentState({state: 'login'}))
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/login/login-result/login-result.component.ts